import { render, staticRenderFns } from "./dashboard-seiasa.vue?vue&type=template&id=3a324b92"
import script from "./dashboard-seiasa.vue?vue&type=script&lang=js"
export * from "./dashboard-seiasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports